import { Models } from "@hex-insights/app-modules";
import { daysOfWeek, fromTime } from "@hex-insights/core";
import { MessageAvailabilityPeriod } from "../../../Utilities";

// Note: the functions defined in this file can be passed to model field components for consistent formatting.

/**
 * Formats the dayOfWeek field of the MessageAvailabilityPeriod model.
 */
export function dayOfWeek(value: MessageAvailabilityPeriod["dayOfWeek"] | null): string {
	if (value === null) {
		return Models.toString(value);
	}
	return daysOfWeek[value] ?? "Invalid Day of Week";
}

/**
 * Formats the startTimeMinutes field of the MessageAvailabilityPeriod model.
 */
export function startTimeMinutes(value: MessageAvailabilityPeriod["startTimeMinutes"] | null): string {
	if (value === null) {
		return Models.toString(value);
	}
	return fromTime(value, "minute").toLocaleString(undefined, { hour: "numeric", minute: "2-digit" });
}

/**
 * Formats the endTimeMinutes field of the MessageAvailabilityPeriod model.
 */
export function endTimeMinutes(value: MessageAvailabilityPeriod["endTimeMinutes"] | null): string {
	if (value === null) {
		return Models.toString(value);
	}
	return fromTime(value, "minute").toLocaleString(undefined, { hour: "numeric", minute: "2-digit" });
}
